window.contactForm = (formID, pageRedirect) => {
    return {
        FORM_ID: parseInt(formID) ?? 0,
        PAGE_REDIRECT: pageRedirect ?? '',
        init() {
            const selectFields = this.$el.getElementsByClassName('wpcf7-select');

            if (this.PAGE_REDIRECT !== '') {
                this.registerPageRedirect();
            }

            pegasus.selectField(selectFields, {
                openOnHover: false,
                itemsToShow: 5,
                firstItemDisabled: true,
                classNames: {
                    outerWrapper:   '',
                    selector:       'Form__Selector flex justify-between w-full cursor-pointer body-small text-greyscale-white-06 transition duration-300 bg-greyscale-white-01 border border-greyscale-white-03 text-left p-4 rounded-md focus:outline-none',
                    selectorOpen:   'rounded-b-none border-b-0',
                    selectionList:  'w-full bg-greyscale-white-01 border border-greyscale-white-03 border-t-0 rounded-b-md px-3',
                    listItem:       'text-greyscale-white-06 body-small font-medium select-none relative py-3 border-t border-dashed border-greyscale-white-04 transition duration-300 hover:bg-greyscale-white-04 focus:bg-greyscale-white-04',
                    listItemFocus:  'bg-blue-100 text-black',
                }
            });
        },
        registerPageRedirect() {

            const formID = this.FORM_ID,
                pageRedirect = this.PAGE_REDIRECT;

            document.addEventListener('wpcf7mailsent', (e) => {

                if (formID === e.detail.contactFormId){
                    location = pageRedirect;
                }

            }, false);

        }

    }
}